import axios from "axios";

const ApimPublicClient = axios.create({
  baseURL: process.env.VUE_APP_APIM_PUBLIC_API_URL,
  timeout: 20000,
  withCredentials: false,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json"
  }
});

export default ApimPublicClient;
export { ApimPublicClient };
